import React, {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {useImmer} from 'use-immer'
import _ from 'lodash'
import axios from 'axios'
import {MultiSelect} from "react-multi-select-component"

import Header from '../map/components/Header'
import PopupDefault from '../map/components/popups/PopupDefault'

import MemberHeader from './parts/MemberHeader'
import MemberFooter from './parts/MemberFooter'

const data = window.pagedata;
const account = data?.account;
const lastUri = location.href.substring(location.href.lastIndexOf('/') + 1)
const is_uri_id = Number.isInteger(parseInt(lastUri))

const onUpdateSubmit = (d) => {

  let err = [];
  if(d.field.email.trim() === '' || d.field.first_name.trim() === ''){

  }

  let i = d.field.studies.length - 1,
  studies = '';
  while(i>=0){
    studies += `(${d.field.id},${d.field.studies[i].value})${i > 0 ? ',' : ''}`;
    i--;
  }

  let fields = {...d.field}
  fields.studies = studies;

  axios.post(
    `/member/${is_uri_id ? 'admin-':''}update`,{
      fields,
      _csrf_token:d._csrf_token
    }
  ).then((r)=>{
    d.setLoader(!1);
    if(r.data.status){
      d.setIsContributor(r.data.is_contributor || false)
      d.setSuccess(true)
    }else{
      d.setError(r.data.msg)
    }
  }).catch((e)=>{
    console.log(e.response);
    // d.setError(e.response)
    d.setLoader(!1);
  })
}

const onSuspendUser = (d) => {
  axios.post(
    `/member/admin-suspend?t=${new Date().getTime()}`,{
      id:account.id,
      status:d.status
    }
  ).then((r)=>{
    d.setLoader(!1);
    if(r.data.status){
      d.setSuccess(`${d.name} ${d.status ? 'activated!' : 'suspended!'}`)
      d.setField(dr => {
        dr.status = d.status;
      });
    }else{
      d.setError(r.data.msg)
    }
  }).catch((e)=>{
    console.log(e.response);
    // d.setError(e.response)
    d.setLoader(!1);
  })
}

const updatePP = (d) => {

  let formData = new FormData();
  formData.append("photo", d.photo ? d.photo[0] : null );
  formData.append("id", account.id);

  axios.post(
    `/member/${window.auth.role === 'ROLE_ADMIN' ? 'admin-update-pp' : 'update-photo'}?t=${new Date().getTime()}`,
    formData,{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  ).then((r)=>{
    document.getElementById('photo-status').innerHTML = '';
    document.getElementById('photo-added').innerHTML = 'Click here to update profile picture...';
    document.getElementById('photo').value = null;
    if(r.data.status){
      if(account.id === window.auth.user_id){
        d.setApp({type:'_AUTH',payload:['photo',r.data.name]})
      }
      d.setPhoto(r.data.name);
      d.setLoaderPP(!1);
      d.setImagePreview(!1);
    }else{
      d.setLoaderPP(!1);
      d.setImagePreview(!1);
    }
  }).catch((e)=>{
    console.log(e.response);
    document.getElementById('photo-status').innerHTML = '';
    document.getElementById('photo-added').innerHTML = 'Click here to update profile picture...';
    document.getElementById('photo').value = null;
  })
}

const previewFile = (d) => {
  const reader = new FileReader();
  reader.addEventListener("load", function () {
    d.setImagePreview(reader.result);
  }, false);
  if (d.file) {
    reader.readAsDataURL(d.file);
  }
}

const MemberAccount = () => {
  const setApp = useDispatch();
  const {first_name,last_name} = useSelector(s=>s.auth);

  const [field,setField] = useImmer({
    id: account.id,
    email: account.email,
    password: '',
    first_name: account.first_name,
    last_name: account.last_name,
    affiliation: account.affiliation,
    roles: account.roles,
    is_contributor: account.is_contributor,
    studies: data.studies || !1,
    status: account.status,
    org_type: account.org_type || '',
    country: account.country || '',
  })
  const [photo,setPhoto] = useState(account.photo?.trim())
  const [imagePreview,setImagePreview] = useState(!1)
  const [changePassword,setChangePassword] = useState(!1)
  const [isContributor,setIsContributor] = useState(account.is_contributor);
  const [contributorStudies,setContributorStudies] = useState(data.studies || []);
  const [error,setError] = useState(!1)
  const [success,setSuccess] = useState(!1)
  const [loader,setLoader] = useState(!1)
  const [loaderPP,setLoaderPP] = useState(!1)

  return  (
    <>
      <Header/>
      <PopupDefault/>

      {
        !first_name ? null : (
          <section id="member-area">

            <MemberHeader title={`Edit ${account.id === window.auth.user_id ? 'Your' : `${field.first_name}'${field.first_name.slice(-1) === 's' ? '' : 's'}`} Account`}/>

            <div id="breadcrumb">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-xs-12">
                    <div className="breadcrumb-items">
                        <ul id="breadcrumbs" className="breadcrumbs">
                          <li><a className="bread-link bread-home" href="/" title="Home">Home/Map</a></li>
                          <li><a className="bread-link" href="/member" title={window.auth.role === 'ROLE_USER' || window.auth.role === 'ROLE_CONTRIBUTOR' ? 'Member Area' : 'Dashboard'}>{window.auth.role === 'ROLE_USER' || window.auth.role === 'ROLE_CONTRIBUTOR' ? 'Member Area' : 'Dashboard'}</a></li>
                          {
                            is_uri_id ? (
                              <li><a className="bread-link" href="/member/all" title="Members">Members</a></li>
                            ) : null
                          }
                          <li><strong className="bread-current">{`${account.id === window.auth.user_id ? 'Your' : `${field.first_name}'${field.first_name.slice(-1) === 's' ? '' : 's'}`} account`}</strong></li>
                        </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="member-block-style">

              <div className="container">
                <div className="row">
                  <div className="col-lg-12 col-xl-9">
                    <h5 className="member-block-title"><i className="fa fa-sliders"/> {`Edit ${account.id === window.auth.user_id ? 'Your' : `${field.first_name}'${field.first_name.slice(-1) === 's' ? '' : 's'}`} Account`}</h5>

                    <div id="member-photo-block" style={{padding:20,background:'linear-gradient(45deg, rgb(38 85 68 / 90%), rgb(192 140 32 / 67%))',border:'1px solid #ced4da',color:'#fff'}}>
                      <div>
                        <div>
                          {
                            photo || imagePreview ? (
                              <div id="form-photo" style={{backgroundImage:`url(${imagePreview || `/photo/${photo}`})`,width:100,height:100}}/>
                            ) : <i className="fa fa-user-circle"/>
                          }
                        </div>
                      </div>
                      <div style={{paddingTop:3}}>
                        <form>
                          <div className="input-group" style={{marginBottom:15}}>
                            <div className="custom-file">
                              <input onChange={()=>{
                                document.getElementById('photo-status').innerHTML = '';
                                document.getElementById('photo-added').innerHTML = 'Click here to update profile picture...';

                                if(document.getElementById('photo').value){
                                  const f = document.getElementById('photo').files[0];
                                  const pn = f['name'];
                                  previewFile({file:f,setImagePreview});
                                  document.getElementById('photo-status').innerHTML = 'Update profile picture with ' + pn + '?';
                                  document.getElementById('photo-added').innerHTML = pn;
                                  setPhoto('');
                                }else{
                                  setImagePreview(!1);
                                  setPhoto(account.photo);
                                }
                              }} type="file" className="custom-file-input" id="photo" required/>
                              <label id="photo-added" className="custom-file-label" htmlFor="photo">Click here to update profile picture...</label>
                            </div>
                          </div>
                          <div id="photo-status" className="text-white mb-3"></div>
                          {
                            loaderPP ? null : (
                              <button className="btn btn-o text-white" style={{borderColor:'#fff'}} onClick={(e)=>{
                                e.preventDefault();
                                  if(photo || document.getElementById('photo').value){
                                    setLoaderPP(1);
                                    document.getElementById('photo-status').innerHTML = `${document.getElementById('photo').value ? 'Uploading...' : 'Deleting...'}  Please wait.`;
                                    updatePP({
                                      setApp,
                                      setPhoto,
                                      setLoaderPP,
                                      setImagePreview,
                                      photo: document.getElementById('photo').files
                                    })
                                  }

                              }}>{imagePreview ? 'Yes, update' : (photo ? 'Remove' : 'Add')} profile picture</button>
                            )
                          }

                        </form>
                      </div>
                    </div>

                    <form>
                      <div style={{padding:20,background:'#f8f8f8',border:'1px solid #ced4da'}}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="first_name"><b style={{fontWeight:500,color:'#836f35'}}>First name</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.first_name = e.target.value;
                                });
                              }} value={field.first_name} placeholder="Enter first name..." type="text" className="form-control" id="first_name" required="required"/>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="last_name"><b style={{fontWeight:500,color:'#836f35'}}>Last name</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.last_name = e.target.value;
                                });
                              }} value={field.last_name} placeholder="Enter last name..." type="text" className="form-control" id="last_name"/>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="affiliation"><b style={{fontWeight:500,color:'#836f35'}}>Institution/Organization/Company name</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.affiliation = e.target.value;
                                });
                              }} value={field.affiliation} placeholder="Enter Institution/Organization/Company name..." type="text" className="form-control" id="affiliation"/>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="org_type"><b style={{fontWeight:500,color:'#836f35'}}>Institution type</b></label>
                              <select onFocus={()=>setSuccess(!1)} className="form-control" value={field.org_type} onChange={(e)=>{
                                setField(d => {
                                  d.org_type = e.target.value;
                                })
                              }}>
                                <option value=''>Choose...</option>
                                <option value='Government'>Government</option>
                                <option value='Education'>Education</option>
                                <option value='Non profit'>Non profit</option>
                                <option value='Media'>Media</option>
                                <option value='Research'>Research</option>
                                <option value='Commercial'>Commercial</option>
                                <option value='Other'>Other</option>
                              </select>
                              {
                                /*
                                <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                  setField(d => {
                                    d.org_type = e.target.value;
                                  });
                                }} value={field.org_type} placeholder="Enter type..." type="text" className="form-control" id="org_type"/>
                                */
                              }

                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="country"><b style={{fontWeight:500,color:'#836f35'}}>Country of residence</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.country = e.target.value;
                                });
                              }} value={field.country} placeholder="Enter country..." type="text" className="form-control" id="country" required="required"/>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="email"><b style={{fontWeight:500,color:'#836f35'}}>Email address</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.email = e.target.value;
                                });
                              }} value={field.email} placeholder="Enter email address..." type="email" className="form-control" id="email" required="required" aria-describedby="emailHelp"/>
                              {
                                account.is_verified && window.auth.role === 'ROLE_ADMIN' ? null : (
                                  <small id="emailHelp" className="form-text">
                                    <span style={{color:'#bf8800'}}>
                                      {
                                        account.is_verified ? (
                                          <><i className="fa fa-info-circle"/> Email address need to be verified again if you change the email {!is_uri_id ? 'and you will be logged out automatically' : ''}</>
                                        ) : (
                                          <><i className="fa fa-exclamation-triangle"/> Email hasn't been verified!</>
                                        )
                                      }
                                    </span>
                                  </small>
                                )
                              }
                            </div>
                          </div>
                        </div>


                        <div className="form-group form-check checkbox">
                          <input
                            type="checkbox"
                            checked={changePassword}
                            onChange={(e)=>{
                              if(!e.target.checked){
                                setField(d => {
                                  d.password = '';
                                });
                              }
                              setChangePassword(e.target.checked);
                            }}
                            className="form-check-input" id="change_password"/>
                          <label className="form-check-label" htmlFor="change_password">Change password?</label>
                        </div>

                        {
                          changePassword ? (
                            <div className="form-group">
                              <label htmlFor="password"><b style={{fontWeight:500,color:'#836f35'}}>Password</b></label>
                              <input onFocus={()=>setSuccess(!1)} onChange={(e)=>{
                                setField(d => {
                                  d.password = e.target.value;
                                });
                              }} value={field.password} placeholder="New password..." type="password" className="form-control" id="password" autoComplete="new-password"/>
                            </div>
                          ) : null
                        }

                        {
                          is_uri_id && (window.auth.role === 'ROLE_ADMIN' || window.auth.role === 'ROLE_EDITOR') ? (
                            <>
                              {
                                account.id === window.auth.user_id ? null : (
                                  <div className="form-group">
                                    <label htmlFor="role"><b style={{fontWeight:500,color:'#836f35'}}>Role</b></label>
                                    <select className="form-control" value={field.roles} onChange={(e)=>{
                                      setSuccess(!1)
                                      setField(d => {
                                        d.roles = e.target.value;
                                        if(e.target.value === '["ROLE_USER"]'){
                                          d.is_contributor = false;
                                          setIsContributor(false);
                                        }
                                      });
                                    }}>
                                      <option value='["ROLE_ADMIN"]'>Administrator</option>
                                      <option value='["ROLE_EDITOR"]'>Data editor</option>
                                      <option value='["ROLE_CONTRIBUTOR"]'>Data contributor</option>
                                      <option value='["ROLE_USER"]'>Public user</option>
                                    </select>
                                  </div>
                                )
                              }

                              {
                                field.roles === '["ROLE_ADMIN"]' || field.roles === '["ROLE_EDITOR"]' ? (
                                  <div className="form-group form-check checkbox">
                                    <input
                                      type="checkbox"
                                      checked={field.is_contributor}
                                      onChange={(e)=>{
                                        setSuccess(!1)
                                        setIsContributor(e.target.checked);
                                        setField(d => {
                                          d.is_contributor = e.target.checked;
                                        });
                                      }}
                                      className="form-check-input" id="is_contributor"/>
                                    <label className="form-check-label" htmlFor="is_contributor">Set as contributor?</label>
                                  </div>
                                ) : null
                              }

                              {
                                /*
                                <div className="form-group">
                                  <label htmlFor="password"><b style={{fontWeight:500,color:'#836f35'}}>Password</b></label>
                                  <input onChange={(e)=>setPassword(e.target.value)} placeholder="Enter password..." type="password" className="form-control" id="password" required="required"/>
                                </div>
                                */
                              }
                            </>
                          ) : null
                        }

                      </div>

                      {
                        is_uri_id && (window.auth.role === 'ROLE_ADMIN' || window.auth.role === 'ROLE_EDITOR') ? (
                          <>
                            {
                              field.roles === '["ROLE_CONTRIBUTOR"]' || isContributor ? (
                                <div className="contributor-studies">
                                  <div className="form-group">
                                    <label htmlFor="studies"><b style={{fontWeight:500,color:'#836f35'}}>{`${account.id === window.auth.user_id ? 'Your' : `${field.first_name}'${field.first_name.slice(-1) === 's' ? '' : 's'}`} studies:`}</b></label>
                                    <MultiSelect hasSelectAll={false}
                                      options={data.all_studies}
                                      value={contributorStudies}
                                      onChange={(d)=>{
                                        setField(dr => {
                                          dr.studies = d
                                        });
                                        setContributorStudies(d);
                                        setSuccess(!1)
                                      }}
                                      labelledBy="All studies"
                                    />
                                    {
                                      field.studies.length ? (
                                        <>
                                          <br/>
                                          <table className="table table-hover">
                                            <thead>
                                              <tr>
                                                <th scope="col">#</th>
                                                <th scope="col" colSpan="2">Study title</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {
                                                field.studies.map((d,i)=>{
                                                  return (
                                                    <tr key={i}>
                                                      <th scope="row">{i+1}</th>
                                                      <td>{d.label}</td>
                                                      <td className="text-right"><i onClick={()=>{
                                                        setSuccess(!1)
                                                        setContributorStudies(contributorStudies.filter(el => el.value !== d.value));
                                                        setField(dr => {
                                                          dr.studies = dr.studies.filter(el => el.value !== d.value)
                                                        })
                                                      }} className="fa fa-trash"/></td>
                                                    </tr>
                                                  )
                                                })
                                              }
                                            </tbody>
                                          </table>
                                        </>
                                      ) : null
                                    }
                                  </div>
                                </div>
                              ) : null
                            }
                          </>
                        ) : null
                      }

                      <br/>

                      {
                        success ? (
                          <>
                            <div className="alert alert-success">
                              <i className="fa fa-check-circle"/> {success !== true ? success : 'Data saved!'}
                            </div>
                          </>
                        ) : null
                      }
                      {
                        loader ? <div className="lds-dual-ring2"></div> : (
                          <div className="row">
                            <div className="col-sm-6">
                              <button type="submit" onClick={
                                () => {
                                  setLoader(1);
                                  setSuccess(!1);
                                  setError(!1);
                                  onUpdateSubmit({
                                    field,setField,
                                    setIsContributor,
                                    setError,
                                    setSuccess,
                                    setLoader,
                                    setApp
                                  })
                                }
                              } className="btn btn-primary">Save</button>
                            </div>
                            {
                              is_uri_id && ((window.auth.role === 'ROLE_ADMIN' || window.auth.role === 'ROLE_EDITOR') && account.id !== window.auth.user_id ) ? (
                                <div className="col-sm-6 text-right">
                                  <button type="submit" onClick={
                                    () => {
                                      setLoader(1);
                                      setSuccess(!1);
                                      setError(!1);
                                      onSuspendUser({
                                        setError,
                                        setSuccess,
                                        setLoader,
                                        setField,
                                        name: field.first_name,
                                        status: field.status ? false : true
                                      });
                                    }
                                  } className="btn btn-warning">{field.status ? (<i className="fa fa-ban"/>) : null} {`${field.status ? 'Suspend this user' : 'Activate this user'}`}</button>
                                </div>
                              ) : null
                            }
                          </div>
                        )
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <MemberFooter/>

          </section>
        )
      }

    </>
  )
}

export default MemberAccount
